import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { IFacilityAllowanceItemsModel } from '../models/CustomerModel';
import { UserSessionService } from 'src/app/services/usersession.service';
import { GeneralService } from 'src/app/services/general.service';
import { IGetPermissionMandatoryField } from '../interface';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-allowance-component',
    templateUrl: 'allowanceShared.component.html',
    styleUrls: ['allowanceShared.component.scss'],
    standalone: false
})
export class AllowanceSharedComponent implements OnInit, OnDestroy {
    @Input() allowanceDataList = [];
    @Input() facilityAllowanceItems: IFacilityAllowanceItemsModel[] = [];
    @Input() miscellaneousSettings;
    @Input() allowanceNotes = '';
    @Input() selectedAllowanceItemId = 0;
    @Output() saveAllowanceEmit = new EventEmitter();
    @Output() saveAllowanceNotesEmit = new EventEmitter();
    @Input() MandatoryFieldFormId = 0;
    allowanceError = false;
    requireAllowanceItemsSelection: boolean;
    selectedAllowanceItemDetail = null;
    EditAllowanceMandateFields: IGetPermissionMandatoryField;
    EditAllowanceField: boolean;
    AllowanceNotesField: boolean;
    subjectAllowance: Subject<any> = new Subject();

    constructor(private generalService: GeneralService,
        private userSessionService: UserSessionService) { }


    ngOnInit(): void {
        if (this.userSessionService.companySettingDetails != undefined) {
            this.requireAllowanceItemsSelection = this.userSessionService.companySettingDetails.General.RequireAllowanceItemsSelection;
        } else {
            this.userSessionService.companysettingEmitter.subscribe((setting) => {
                this.requireAllowanceItemsSelection = setting.General.RequireAllowanceItemsSelection;
            });
        }
        if (this.MandatoryFieldFormId != 0) {
            this.setMandatoryField();
        }
        this.subjectAllowance.subscribe(event => {
            this.giveAllowance(event.Value, event.Item);
        });
    }

    giveAllowanceSubjectCall(eve, item) {
        const object = {
            Value: eve.target.value,
            Item: item
        };
        this.subjectAllowance.next(object);
    }

    giveAllowance(value, item) {
        if (value === "" || value == null) {
            item.Allowance = "";
            item.Balance = parseFloat(item.totalAmount);
            return;
        }
        let allowance = value;
        if (allowance > item.totalAmount) {
            item.Allowance = parseFloat(parseFloat(item.totalAmount).toFixed(2));
        } else {
            item.Allowance = parseFloat(parseFloat(allowance).toFixed(2));
        }
        let total = parseFloat((parseFloat(item.totalAmount) - parseFloat(item.Allowance)).toFixed(2));
        item.Balance = total;
        this.allowanceDataList.forEach(all => {
            if (all.Allowance == "" || all.Allowance == undefined) {
                all.Allowance = 0;
            }
            if (all.Allowance > all.totalAmount) {
                all.Allowance = parseFloat(parseFloat(all.totalAmount).toFixed(2));
            } else {
                all.Allowance = parseFloat(all.Allowance.toFixed(2));
            }
            let total = parseFloat((parseFloat(all.totalAmount) - parseFloat(all.Allowance)).toFixed(2));
            all.Balance = total;
        });
        let error = this.VerifyErrorAllowanceItemValue();
        const saveObj = {
            Data: this.allowanceDataList,
            AllowanceItemId: this.selectedAllowanceItemId,
            ErrorIdAllowance: error
        }
        this.saveAllowanceEmit.emit(saveObj);
    }

    VerifyErrorAllowanceItemValue() {
        const selectedAllowanceItem = this.facilityAllowanceItems.find(x => x.Id == this.selectedAllowanceItemId);
        if (selectedAllowanceItem && this.existsAllowanceRecord()) {
            let combinedAllowance = this.allowanceDataList.reduce(function (accumulator, item) {
                const allowanceVal = item.Allowance == '' || item.Allowance == undefined ? 0 : parseFloat(item.Allowance);
                return accumulator + allowanceVal;
            }, 0);
            if (selectedAllowanceItem.Type == 583) {
                if (combinedAllowance > selectedAllowanceItem.MaxValue) {
                    return 1;
                }
                if (combinedAllowance < selectedAllowanceItem.Value) {
                    return 2;
                }
            } else {
                if (combinedAllowance != selectedAllowanceItem.Value) {
                    return 3;
                }
            }
            return 0;
        }
        return 0;
    }

    emitAllowanceNotes() {
        this.saveAllowanceNotesEmit.emit(this.allowanceNotes);
    }

    ngOnDestroy() {
        const error = this.VerifyErrorAllowanceItemValue();
        const saveObj = {
            Data: this.allowanceDataList,
            AllowanceItemId: this.selectedAllowanceItemId,
            ErrorIdAllowance: error
        }
        this.saveAllowanceEmit.emit(saveObj);
        this.saveAllowanceNotesEmit.emit(this.allowanceNotes);
    }

    changeAllowanceItem(itemId) {
        this.selectedAllowanceItemId = itemId;
        this.allowanceDataList.forEach(data => {
            data.Allowance = 0;
            data.Balance = data.totalAmount;
        });
        this.selectedAllowanceItemDetail = itemId == 0 ? null : this.facilityAllowanceItems.find(x => (x.Id == itemId));
        const error = this.VerifyErrorAllowanceItemValue();
        const saveObj = {
            Data: this.allowanceDataList,
            AllowanceItemId: this.selectedAllowanceItemId,
            ErrorIdAllowance: error
        }
        this.saveAllowanceEmit.emit(saveObj);
    }

    existsAllowanceRecord() {
        if (this.allowanceDataList.length > 0) {
            const existAllowance = this.allowanceDataList.find(all => (all.totalAmount != 0));
            if (existAllowance) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
        return false;
    }

    setMandatoryField() {
        this.generalService.GetMandatoryFieldsById(null, this.MandatoryFieldFormId)
            .subscribe((response: IGetPermissionMandatoryField) => {
                this.EditAllowanceMandateFields = response;
                this.EditAllowanceField = this.EditAllowanceMandateFields.Form.ListOfProperties.find(o => o.Name === 'Allowance').Required;
                this.AllowanceNotesField = this.EditAllowanceMandateFields.Form.ListOfProperties.find(o => o.Name === 'allowanceNotes').Required;
            });
    }

    disableAllowanceNote() {
        if ((!this.allowanceDataList.some((ele) => ele.Allowance !== 0)) ||
            (!this.allowanceDataList.some((ele) => ele.Allowance !== null)) || (!this.allowanceDataList.some((ele) => ele.Allowance !== ''))
            || (!this.allowanceDataList.some((ele) => ele.Allowance !== '0'))) {
            this.allowanceNotes = '';
            this.saveAllowanceNotesEmit.emit(this.allowanceNotes);
            return true;
        }
        return false;
    }

    disableAllowanceItemSelection() {
        if (this.facilityAllowanceItems && this.facilityAllowanceItems.length) {
            return false;
        }
        return true;
    }

    onBlurHandler(item: any): void {
        item.Allowance = item.Allowance ? item.Allowance : 0;
        this.giveAllowance(item.Allowance, item);
    }
}
